import column from '../../abstract/column';
import vars from '../../abstract/vars.js';
import api, { modelName } from './api';

export const orderStatusOptions = {
  new: {
    label: 'Nowe',
    value: 'new',
    color: 'danger',
  },
  processing: {
    label: 'Przetwarzanie płatności',
    value: 'processing',
    color: 'warning',
  },
  completed: {
    label: 'Zrealizowane',
    value: 'completed',
    color: 'success',
  },
};

export const parseSubscriptionOrderItems = (item) => {
  return Array.from(item.subscriptionorderitem).map(e => e.subscriptionoffer?.label).join(', ');
};

export default {
  actions: {},
  topRightActions: {},
  api,
  modelName,
  sidebarData: {
    id: column({
      label: 'Identyfikator',
      size: 100
    }),
  },
  columns: {
    created_at: column({
      label: 'Data dodania',
    }),
    status: column({
      label: 'Status',
      component: 'value-status',
      options: orderStatusOptions,
    }),
    total: column({
      component: 'value-money',
      label: 'Cena',
      format: (item) => ({ value: item.total, currency: item.currency }),
    }),
    items: column({
      label: 'Opis zamówienia',
      format: (item) => parseSubscriptionOrderItems(item),
    }),
  },
  vars: vars({
    noItemsText: () => 'Brak zamówień',
    sidebarLabel: () => 'Podgląd zamówienia',
  }),
};
